import { useEffect } from 'react';
import forEach from 'lodash/forEach';
import isString from 'lodash/isString';

export const getOptionLabel = option =>
  isString(option) ? option : option.label || option.value;

export const setElementRefs = refs => element => {
  forEach(refs, ref => {
    if (typeof ref === 'function') {
      ref(element);
    } else {
      // eslint-disable-next-line
      ref.current = element;
    }
  });
};

export const useWindowBinding = (type, fn, deps = []) => {
  useEffect(() => {
    document.addEventListener(type, fn);
    return () => {
      document.removeEventListener(type, fn);
    };
  }, deps);
};

export const getCycledIndex = (index, length) => {
  if (index == null) {
    return index;
  }
  return (index + length) % length;
};

export const invokeRef = ref => () => {
  if (ref.current) {
    ref.current();
  }
};

export const isActive = ref => ref.current === document.activeElement;

export const isBlurToElement = (event, element) => {
  // Based on solution from thread: https://github.com/facebook/react/issues/2011
  // Some browsers (IE11) do not correctly set `relatedTarget` when blur is going to another item:
  const relatedTarget =
    event.relatedTarget ||
    event.explicitOriginalTarget ||
    document.activeElement; // IE11

  return relatedTarget && element && element.contains(relatedTarget);
};
